import { Chip, CircularProgress } from '@mui/material'

export default function ChatMessageLoading() {
  return (
    <Chip
      icon={
        <CircularProgress
          sx={{
            width: '30px!important',
            height: 'auto!important',
            p: '0.4rem',
          }}
        />
      }
      label="Loading..."
      sx={{
        fontSize: '.75rem',
        width: 'fit-content',
        backgroundColor: t => t.palette.agentChat.darkGray,
      }}
    />
  )
}
